import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientStats = ({ clients }) => {
  const calculateStats = () => {
    const total = clients?.length;
    const statusCounts = clients?.reduce((acc, client) => {
      acc[client.status] = (acc?.[client?.status] || 0) + 1;
      return acc;
    }, {});

    const thisMonth = new Date();
    thisMonth?.setDate(1);
    thisMonth?.setHours(0, 0, 0, 0);

    const newThisMonth = clients?.filter(client => 
      new Date(client.inquiryDate) >= thisMonth
    )?.length;

    const conversionRate = total > 0 ? ((statusCounts?.booked || 0) / total * 100)?.toFixed(1) : 0;

    return {
      total,
      new: statusCounts?.new || 0,
      contacted: statusCounts?.contacted || 0,
      qualified: statusCounts?.qualified || 0,
      booked: statusCounts?.booked || 0,
      completed: statusCounts?.completed || 0,
      cancelled: statusCounts?.cancelled || 0,
      newThisMonth,
      conversionRate
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      title: 'Total Clients',
      value: stats?.total,
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'New This Month',
      value: stats?.newThisMonth,
      icon: 'UserPlus',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      title: 'Active Bookings',
      value: stats?.booked,
      icon: 'Calendar',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      title: 'Conversion Rate',
      value: `${stats?.conversionRate}%`,
      icon: 'TrendingUp',
      color: 'text-amber-600',
      bgColor: 'bg-amber-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards?.map((card, index) => (
        <div key={index} className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-body text-sm text-muted-foreground mb-1">{card?.title}</p>
              <p className="text-2xl font-heading font-semibold text-primary">{card?.value}</p>
            </div>
            <div className={`w-12 h-12 ${card?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStats;